import { useCallback } from "react";
import { useShallow } from "zustand/react/shallow";

import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import { MessageBubble, Book, Bulb } from "components/icons/generated";
import SpaceliftLogo from "ds/components/SpaceliftLogo/Logo";
import Icon from "ds/components/Icon";
import TileWrapper from "ds/components/Tile/Wrapper";
import TileContent from "ds/components/Tile/Content";
import IconEmphasized from "ds/components/IconEmphasized";
import TileTitle from "ds/components/Tile/Title";
import TileDescription from "ds/components/Tile/Description";

import styles from "./styles.module.css";
import useAssistantPanelStore from "../Layout/useStore";
import { AssistantPanelMode } from "../Layout/types";
import AssistantPanelLayoutHeader from "../Layout/Header";

const AssistantPanelHome = () => {
  const { switchMode } = useAssistantPanelStore(
    useShallow((state) => ({
      switchMode: state.switchMode,
    }))
  );

  const handleAskMode = useCallback(() => {
    switchMode(AssistantPanelMode.AI_CHAT);
  }, [switchMode]);

  const handleLearnMode = useCallback(() => {
    switchMode(AssistantPanelMode.LEARN);
  }, [switchMode]);

  return (
    <Box direction="column" fullHeight>
      <AssistantPanelLayoutHeader />
      <Box
        direction="column"
        align="center"
        padding="x-large"
        gap="medium"
        scrollable
        className={styles.homeContent}
      >
        <Box align="center" justify="center">
          <SpaceliftLogo size="medium" />
        </Box>

        <Box direction="column" align="center" gap="small">
          <Typography tag="h2" variant="p-t6" align="center">
            Meet Saturnhead
          </Typography>
          <Typography tag="p" variant="p-body3" align="center" color="primary">
            I can help you learn Spacelift or answer questions as you work.
            <br />
            Choose a mode to get started:
          </Typography>
        </Box>

        <Box gap="small" direction="column" fullWidth>
          <TileWrapper key="ask" onClick={handleAskMode} fullWidth className={styles.tile}>
            <TileContent direction="row" gap="large" align="center">
              <IconEmphasized icon={MessageBubble} variant="secondary" />
              <Box direction="column" gap="small">
                <TileTitle variant="p-t7">Ask</TileTitle>
                <TileDescription>
                  Ask about features, docs, troubleshooting, or how Spacelift works.
                </TileDescription>
              </Box>
            </TileContent>
          </TileWrapper>

          <TileWrapper key="learn" onClick={handleLearnMode} fullWidth className={styles.tile}>
            <TileContent direction="row" gap="large" align="center">
              <IconEmphasized icon={Book} variant="secondary" />
              <Box direction="column" gap="small">
                <TileTitle variant="p-t7">Learn</TileTitle>
                <TileDescription>
                  Go through interactive onboarding scenarios at your own pace.
                </TileDescription>
              </Box>
            </TileContent>
          </TileWrapper>
        </Box>

        <Box align="center" gap="small">
          <Icon color="warning" src={Bulb} noShrink />
          <Typography tag="p" variant="p-body3" color="primary">
            You can switch modes anytime using the dropdown inside chat.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AssistantPanelHome;
